export const figma = {
  clientId: import.meta.env.VITE_FIGMA_CLIENT_ID,
  baseUrl: import.meta.env.VITE_FIGMA_BASE_AUTH_URL,
  oidcProvider: import.meta.env.VITE_FIGMA_OIDC_PROVIDER,
};
